import { render } from "./ui-image.vue?vue&type=template&id=00ed74c6&scoped=true"
import script from "./ui-image.vue?vue&type=script&lang=js"
export * from "./ui-image.vue?vue&type=script&lang=js"

import "./ui-image.vue?vue&type=style&index=0&id=00ed74c6&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ed74c6"],['__file',"src/components/ui/ui-image.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00ed74c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00ed74c6', __exports__)) {
    api.reload('00ed74c6', __exports__)
  }
  
  module.hot.accept("./ui-image.vue?vue&type=template&id=00ed74c6&scoped=true", () => {
    api.rerender('00ed74c6', render)
  })

}


export default __exports__